import { request } from "services/api/util";

class RewardCategoryService {
  async getListRewardCategory(params) {
    const config = {
      method: "get",
      url: `admin/rewardCategory`,
      params: params,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async getDetailRewardCategory(id) {
    const config = {
      method: "get",
      url: `admin/rewardCategory/${id}`,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async createRewardCategory(body) {
    const config = {
      method: "post",
      url: `admin/rewardCategory`,
      data: body,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async updateRewardCategory(body, id) {
    const config = {
      method: "put",
      url: `admin/rewardCategory/${id}`,
      data: body,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }
}

export default new RewardCategoryService();
